<template>
    <div class="col-xs-10 col-xs-offset-1">
        <div class="row">
            <div class="form-group col-xs-6">
                <label>From</label>
                <datepicker :calendar-button="calendar" :calendar-button-icon="calendarClass" :clear-button="clear" :clear-button-icon="clearClass" :disabledDates="fromDisabledDates" :input-class="inputClass" :format="dateFormat" v-model="paramsFrom"></datepicker>
            </div>
            <div class="form-group col-xs-6">
                <label>To</label>
                <datepicker :calendar-button="calendar" :calendar-button-icon="calendarClass" :clear-button="clear" :clear-button-icon="clearClass" :disabledDates="toDisabledDates" :input-class="inputClass" :format="dateFormat" v-model="paramsTo"></datepicker>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'

    export default {
        props: ['params'],
        name: 'SearchDateRange',
        components: {Datepicker},
        data () {
            return {
                dateFormat: 'yyyy-MM-dd',
                inputClass: 'form-control',
                calendar: true,
                clear: true,
                calendarClass: 'glyphicon glyphicon-calendar',
                clearClass: 'glyphicon glyphicon-remove'
            }
        },
        computed: {
            paramsFrom: {
                get () {
                    return this.params !== null
                        ? this.params.from
                            ? this.params.from + 'T00:00:00'
                            : ''
                        : ''
                },
                set (newValue) {
                    this.$emit('update:params', {
                        from: newValue ? this.$options.filters.formatDate(newValue.toISOString(), 'YYYY-MM-DD') : '',
                        to: this.params.to
                    })
                }
            },
            paramsTo: {
                get () {
                    return this.params !== null
                        ? this.params.to
                            ? this.params.to + 'T00:00:00'
                            : ''
                        : ''
                },
                set (newValue) {
                    this.$emit('update:params', {
                        from: this.params.from,
                        to: newValue ? this.$options.filters.formatDate(newValue.toISOString(), 'YYYY-MM-DD') : ''
                    })
                }
            },
            fromDisabledDates () {
                if (!this.paramsTo) {
                    return {}
                }

                return {
                    from: new Date(this.paramsTo)
                }
            },
            toDisabledDates () {
                if (!this.paramsFrom) {
                    return {}
                }

                return {
                    to: new Date(this.paramsFrom)
                }
            }
        },
        methods: {},
        created () {
            if (this.params === null) {
                this.$emit('update:params', {
                    from: '',
                    to: ''
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// SearchDateRange.vue?751635d4